module.exports = __webpack_public_path__ + "static/media/mass_adaption.00e2c846.jpg";